import packageInfo from "../../package.json";

export const environment = {
  appVersion: packageInfo.version,
  production: false,
  API_DOMAIN: "https://back-qa-velo.betacore.pro/api/v1",
  maxRecordingSeconds: 30,
  maxRecordingAttempts: 3,
  SERVICES: {
    LOGIN: `/auth/login`,
    LOGOUT: `/auth/logout`,
    REFRESH: `/auth/refresh`,
    PASSWORD_RECOVERY_REQUEST: `/auth/password-recovery/request`,
    PASSWORD_RECOVERY_VERIFY: `/auth/password-recovery/verify`,
    PASSWORD_RECOVERY_RESET: `/auth/password-recovery/reset`,
    MUNICIPALITIES: `/municipalities`,
    SUPPORT_CHANNELS: `/support-channels`,
    ADMIN_BANNERS: `/admin/banners`,
    ADMIN_BUSINESSES: `/admin/businesses`,
    SOCIAL_NETWORKS: `/social-networks`,
    ADMIN_CUSTOMERS: `/admin/customers`,
    ADMIN_ADMINISTRATORS: `/admin/administrators`,
    ADMIN_DASHBOARD: `/admin/dashboard`,
    CATEGORIES: `/categories`,
    QR_CODES: `/qr-codes`,
    QR_BATCHES: `/qr-batches`,
    ORGANIZATIONS: `/organizations`,
    USERS: `/users`,
    HOLIDAY_THEMES: `/holiday-themes`,
    UPLOAD_MEDIA: `/uploads/media`,
  },
};
